export const cn = {
    title: {
        manageSubscription: '管理订阅',
        pickYourPlan: '选择计划',
        basicUser: '选择适合您的计划',
        proUser: '管理订阅',
    },
    subtitle: {
        pickYourPlan: '选择适合您的计划',
        basicUser: '解锁专业功能，提升您的生产力',
        proUser: '管理您的订阅',
    },
    recommend: '推荐',
    currentPlan: '当前方案',
    active: '已激活',
    canceled: '已取消',
    changePlan: '切换方案',
    cancelPlan: '取消方案',
    resumePlan: '恢复方案',
    month: '月',
    year: '年',
    flashSale: '闪促 50% OFF',
    billingCycle: {
        monthly: '月付',
        yearly: '年付',
        saveAmount: '省 $ {amount}',
    },
    plans: {
        basic: {
            sectionTitle: '您的试用方案',
            featureTitle: '试用方案功能:',
            name: 'Eureka Vault 试用版',
            description: '适用于个人试用',
            buttonText: '试用 Eureka Vault',
            featuresHeader: '用量限额:',
            features: {
                0: '100 篇文档额度 (10 页/篇)',
            },
        },
        pro: {
            sectionTitle: '您的方案',
            featureTitle: '个人付费版功能',
            name: 'Eureka Vault 个人付费版',
            description: '适用于专业学习和研究',
            buttonText: '升级',
            featuresHeader: '用量限额:',
            features: {
                0: '300 篇文档额度 (30 页/篇)',
            },
        },
        enterprise: {
            name: 'Eureka Vault 企业版',
            description: '适用于日常研究和工作需求',
            buttonText: '升级',
            featuresHeader: '用量限额:',
            features: {
                0: '1000 篇文档额度 (100 页/篇)',
            },
        },
        api: {
            name: 'API',
            description: '解锁完整访问权限并体验最新功能',
            buttonText: '了解更多',
            featuresHeader: '包含专业版,以及:',
            features: {
                0: '####',
                1: '####',
                2: '####',
                3: '####',
            },
        },
    },
    viewMoreDetails: '查看更多详情',
    error: {
        createPaymentSessionFailed: '创建支付失败,请稍后重试',
    },
};

export const en = {
    title: {
        manageSubscription: 'Manage Subscription',
        pickYourPlan: 'Pick your plan',
        basicUser: 'Choose the Right Plan for You',
        proUser: 'Manage Subscription',
    },
    subtitle: {
        pickYourPlan: 'Choose the plan that works for you',
        basicUser: 'Unlock professional features and boost your productivity.',
        proUser: 'Manage your subscription',
    },
    recommend: 'Recommend',
    currentPlan: 'Current Plan',
    active: 'ACTIVE',
    canceled: 'Canceled',
    changePlan: 'Change plan',
    cancelPlan: 'Cancel plan',
    resumePlan: 'Resume plan',
    month: 'month',
    year: 'year',
    flashSale: 'Flash Sale 50% OFF',
    billingCycle: {
        monthly: 'Monthly',
        yearly: 'Yearly',
        saveAmount: 'Save $ {amount}',
    },
    plans: {
        basic: {
            sectionTitle: 'Your Trial Plan',
            featureTitle: 'Trial Plan Features:',
            name: 'Eureka Vault Trial',
            description: 'For personal trial',
            buttonText: 'Try Eureka Vault',
            featuresHeader: 'Usage Quota:',
            features: {
                0: '100 documents (10 pages/doc) quota',
            },
        },
        pro: {
            sectionTitle: 'Your Plan',
            featureTitle: 'Personal Plan Features',
            name: 'Eureka Vault Personal',
            description: 'For professional learning and research',
            buttonText: 'Upgrade',
            featuresHeader: 'Usage Quota:',
            features: {
                0: '300 documents (30 pages/doc) quota',
            },
        },
        enterprise: {
            name: 'Eureka Vault Enterprise',
            description: 'For daily research and work needs',
            buttonText: 'Upgrade',
            featuresHeader: 'Usage Quota:',
            features: {
                0: '1000 documents (100 pages/doc) quota',
            },
        },
        api: {
            name: 'API',
            description: 'Unlock full access and experience the latest features',
            buttonText: 'Learn more',
            featuresHeader: 'Includes Pro, plus:',
            features: {
                0: '####',
                1: '####',
                2: '####',
                3: '####',
            },
        },
    },
    viewMoreDetails: 'View more details',
    error: {
        createPaymentSessionFailed: 'Failed to create payment, please try again later',
    },
};

export const jp = {
    title: {
        manageSubscription: 'サブスクリプション管理',
        pickYourPlan: 'プランを選択',
        basicUser: 'あなたに合ったプランを選択',
        proUser: 'サブスクリプション管理',
    },
    subtitle: {
        pickYourPlan: 'あなたに合ったプランをお選びください',
        basicUser: 'プロフェッショナル機能をアンロックし、生産性を向上',
        proUser: 'サブスクリプション管理',
    },
    recommend: 'おすすめ',
    currentPlan: '現在のプラン',
    active: '有効',
    canceled: 'キャンセル済み',
    changePlan: 'プラン変更',
    cancelPlan: 'プランキャンセル',
    resumePlan: 'プラン再開',
    month: '月',
    year: '年',
    flashSale: '閃促 50% OFF',
    billingCycle: {
        monthly: '月払い',
        yearly: '年払い',
        saveAmount: '$ {amount} お得',
    },
    plans: {
        basic: {
            sectionTitle: 'トライアルプラン',
            featureTitle: 'トライアルプラン機能:',
            name: 'Eureka Vault トライアル',
            description: '個人トライアル向け',
            buttonText: 'Eureka Vaultを試す',
            featuresHeader: '使用量制限:',
            features: {
                0: '100件 (10ページ/件) のドキュメント',
            },
        },
        pro: {
            sectionTitle: 'パーソナルプラン',
            featureTitle: 'パーソナルプラン機能',
            name: 'Eureka Vault パーソナル',
            description: '専門学習と研究向け',
            buttonText: 'アップグレード',
            featuresHeader: '使用量制限:',
            features: {
                0: '300件 (30ページ/件) のドキュメント',
            },
        },
        enterprise: {
            name: 'Eureka Vault エンタープライズ',
            description: '日常の研究と業務向け',
            buttonText: 'アップグレード',
            featuresHeader: '使用量制限:',
            features: {
                0: '1000件 (100ページ/件) のドキュメント',
            },
        },
        api: {
            name: 'API',
            description: 'フルアクセスと最新機能をご体験ください',
            buttonText: '詳細を見る',
            featuresHeader: 'プロ版に加えて:',
            features: {
                0: '####',
                1: '####',
                2: '####',
                3: '####',
            },
        },
    },
    viewMoreDetails: '詳細を見る',
    error: {
        createPaymentSessionFailed: '支払いの作成に失敗しました,後でもう一度お試しください',
    },
};

export const tw = {
    title: {
        manageSubscription: '管理訂閱',
        pickYourPlan: '選擇方案',
        basicUser: '選擇適合您的方案',
        proUser: '管理訂閱',
    },
    subtitle: {
        pickYourPlan: '選擇適合您的方案',
        basicUser: '解鎖專業功能，提升您的生產力',
        proUser: '管理您的訂閱',
    },
    recommend: '推薦',
    currentPlan: '目前方案',
    active: '已啟用',
    canceled: '已取消',
    changePlan: '切換方案',
    cancelPlan: '取消方案',
    resumePlan: '恢復方案',
    month: '月',
    year: '年',
    flashSale: '閃促 50% OFF',
    billingCycle: {
        monthly: '月付',
        yearly: '年付',
        saveAmount: '省 $ {amount}',
    },
    plans: {
        basic: {
            sectionTitle: '您的試用方案',
            featureTitle: '試用方案功能:',
            name: 'Eureka Vault 試用版',
            description: '適用於個人試用',
            buttonText: '試用 Eureka Vault',
            featuresHeader: '用量限額:',
            features: {
                0: '100 篇文檔額度 (10 頁/篇)',
            },
        },
        pro: {
            sectionTitle: '您的方案',
            featureTitle: '個人付費版功能',
            name: 'Eureka Vault 個人付費版',
            description: '適用於專業學習和研究',
            buttonText: '升級',
            featuresHeader: '用量限額:',
            features: {
                0: '300 篇文檔額度 (30 頁/篇)',
            },
        },
        enterprise: {
            name: 'Eureka Vault 企業版',
            description: '適用於日常研究和工作需求',
            buttonText: '升級',
            featuresHeader: '用量限額:',
            features: {
                0: '1000 篇文檔額度 (100 頁/篇)',
            },
        },
        api: {
            name: 'API',
            description: '解鎖完整存取權限並體驗最新功能',
            buttonText: '了解更多',
            featuresHeader: '包含專業版,以及:',
            features: {
                0: '####',
                1: '####',
                2: '####',
                3: '####',
            },
        },
    },
    viewMoreDetails: '查看更多详情',
    error: {
        createPaymentSessionFailed: '创建支付失败,请稍后重试',
    },
};
